import { RepeatIcon } from '@chakra-ui/icons'
import { Box, Flex } from '@chakra-ui/react'
import { FieldTypes, TextAreaField } from '@hb/shared'
import { useField } from 'react-final-form'
import { ActionButton } from '../../../../components/Buttons'
import TextArea from '../../../../components/forms/Input/Text/TextArea/TextArea'
import { SectionLabel } from '../../SectionLabel'
import { useAutofill } from '../AutofillContext'

// Stable field schema (module-level so the reference never changes between renders).
const notesField: TextAreaField = {
  type: FieldTypes.TEXTAREA,
  placeholder: 'Notes...',
  optional: true,
  withDotPhrases: true,
  minRows: 4,
}

export const EncounterNotesInput = ({ canEdit }: { canEdit: boolean }) => {
  // `active` is included so the field still shows its focus styling; both `value` and `active`
  // change at human speed, so this keeps re-renders scoped to this component.
  const { input, meta } = useField<string>('data.notes', {
    subscription: { value: true, active: true },
  })
  const { canRegenerateAutofill, regenerateAutofill, autofilling } = useAutofill()
  return (
    <Box data-child-name="data.notes" w="100%" px={5} py="14px">
      <SectionLabel mb={1}>Notes</SectionLabel>
      {/* Shared dot-phrase TextArea so '.'/Tab template expansion works in the Notes field. */}
      <TextArea field={notesField} input={input} meta={meta} disabled={!canEdit} />
      {/* Shown once the provider has advanced past the notes step — re-run autofill after editing notes. */}
      {canRegenerateAutofill && (
        <Flex justify="flex-end" mt={2}>
          <ActionButton
            size="xs"
            opacity={input.value ? 1 : 0.5}
            disabled={!input.value || autofilling}
            leftIcon={<RepeatIcon />}
            onClick={regenerateAutofill}
            isLoading={autofilling}>
            Autofill fields from notes
          </ActionButton>
        </Flex>
      )}
    </Box>
  )
}
